module.exports = __webpack_public_path__ + "img/mv01.ee8ae00a.png";